module.exports = __webpack_public_path__ + "static/media/battles-streak-info.2bc3349f.png";